import { useEffect, useState } from "react"
import CustomizedDialogs from "../../atoms/dialog"
import { useDispatch } from "react-redux";
import { Grid } from "@material-ui/core";
import { UtilityFunctionList } from "./UtilityFunctionList";
import { UtilityFunctionFormEditor } from "./UtilityFunctionFormEditor";
import { invokeGetService } from "../../../store/global/actions";


export const UtilityFunctionDialog = ({ handleClose, selectedUtilityFunction, setSelectedUtilityFunction }) => {
    const dispatch = useDispatch();

    const [isFetching, setIsFetching] = useState(false);
    const [utilityFunctions, setUtilityFunctions] = useState([]);

    useEffect(() => {
        fetchUtilityFunctions();
    }, []);

    const fetchUtilityFunctions = () => {
        setIsFetching(true);
        dispatch(invokeGetService('getAllUtilityFunctions', []))
            .then((response) => {
                if (response.status && response.data) {
                    const sortedUtilityFunctions = response?.data?.filter(item => item.name)?.sort((a, b) => a?.order - b?.order);
                    setUtilityFunctions(sortedUtilityFunctions);
                    const selectedUtilityFunctionObj = response.data.find(uf => uf._id.toString() === selectedUtilityFunction?._id);
                    setSelectedUtilityFunction(selectedUtilityFunctionObj);
                }
                setIsFetching(false);
            });
    }


    return (
        <CustomizedDialogs 
        container_id="utility-function-dialog" 
        title={`Utility Function - ${selectedUtilityFunction?.name || "Create"}`} 
        open={true} 
        handleClose={handleClose}
        isTitleCapital={false}
        >
            <Grid container>
                <Grid xs={3} style={{ padding: "0px 10px 0px 0px" }}>
                    <UtilityFunctionList utilityFunctions={utilityFunctions} setSelectedUtilityFunction={setSelectedUtilityFunction} selectedUtilityFunction={selectedUtilityFunction} isFetching={isFetching} />
                </Grid>
                <Grid xs={9}>
                    <UtilityFunctionFormEditor utilityFunctions={utilityFunctions} selectedUtilityFunction={selectedUtilityFunction} isFetching={isFetching} handleClose={handleClose}/>
                </Grid>
            </Grid>
        </CustomizedDialogs>
    )
}